import { render } from "./Digitize-product-page.vue?vue&type=template&id=58436fb0&scoped=true"
import script from "./Digitize-product-page.vue?vue&type=script&lang=js"
export * from "./Digitize-product-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=58436fb0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58436fb0"]])

export default __exports__